<!--
// app/components/Shared/HeaderBannerTitle.vue
-->
<script setup lang="ts">
import { useWebContext } from "~/app/composables/webContext";
import { useRegions } from "~/app/composables/regions";

type Props = {
  title: string;
};

defineProps<Props>();

const { isKings } = useWebContext();
const { isMena } = useRegions();
</script>

<template>
  <div
    :class="[
      'flex items-center justify-between align-center px-4 md:ps-20 py-6 md:py-20 bg-blend-difference',
      isKings ? 'kql-banner-gradient-kings' : 'kql-banner-gradient-queens',
      { inverted: isMena },
    ]"
  >
    <h1
      :class="[
        'text-transparent uppercase text-3xl md:text-6xl kql-banner-font-family bg-gradient-to-r inline-block bg-clip-text',
        isKings ? 'from-secondary to-primary' : 'from-primary to-secondary',
        { '!leading-normal': isMena },
      ]"
    >
      {{ title }}
    </h1>
  </div>
</template>

<style scoped>
.kql-banner-gradient-kings {
  @apply bg-none md:bg-opacity-30 md:bg-[url("/img/header/header-title-texture.png"),url("/img/header/header-title-decoration.png")];
  background-repeat: repeat-x, no-repeat;
  background-position:
    center left,
    center right;
  background-size:
    auto 130%,
    auto 100%;
}

.kql-banner-gradient-kings.inverted {
  @apply bg-none md:bg-opacity-30 md:bg-[url("/img/header/header-title-texture.png"),url("/img/header/header-title-decoration-rtl.png")];
  background-repeat: repeat-x, no-repeat;
  background-position:
    center right,
    center left;
  background-size:
    auto 130%,
    auto 100%;
}

.kql-banner-gradient-queens {
  @apply bg-none md:bg-opacity-30 md:bg-[url("/img/header/header-title-texture.png"),url("/img/header/header-title-decoration-queens.png")];
  background-repeat: repeat-x, no-repeat;
  background-position:
    center left,
    center right;
  background-size:
    auto 130%,
    auto 100%;
}

.kql-banner-font-family {
  @apply font-black font-['Archivo_Expanded'];
}
</style>
